<template>
  <div>
    <v-client-table
      ref="tablePanneaux"
      :data="items"
      :columns="columns"
      :options="options">
      <div slot="actionGeo" slot-scope="props">
        <b-button
          type="is-primary"
          expanded
          icon-right="open-in-new"
          @click="ouvrirNouvelleFenetreNoGeo(props.row.num)">
          Géolocaliser
        </b-button>
      </div>
      <div slot="actionPhoto" slot-scope="props">
        <b-button
          type="is-primary"
          expanded
          icon-right="open-in-new"
          @click="ouvrirNouvelleFenetrePhoto(props.row.facNum)">
          Modifier
        </b-button>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';

const User = createNamespacedHelpers('user');

export default {
  props: {
    isListNoGoe: Boolean,
    dataList: Array,
  },
  data() {
    return {
      trad: {
        code: '↑↓ Panneau',
        facCode: '↑↓ Face',
        format: '↑↓ Format',
        materiel: '↑↓ Matériel',
        adresse: '↑↓ Adresse',
        codePostal: '↑↓ CP',
        ville: '↑↓ Ville',
        codeDepartement: '↑↓ Département',
        actionGeo: 'Géolocalisation',
        actionPhoto: 'Photo',
      },
    };
  },
  computed: {
    ...User.mapGetters({
      site: 'site',
    }),
    columns() {
      const tab = ['code', 'facCode', 'format', 'materiel', 'adresse', 'codePostal', 'ville', 'codeDepartement', 'actionGeo'];
      if (!this.isListNoGoe) {
        tab.pop();
        tab.push('actionPhoto');
      }
      return tab;
    },
    items() {
      return this.dataList.map(el => {
        const adresse = [];
        if (el.adresseCommercialeLibelle1) adresse.push(el.adresseCommercialeLibelle1);
        if (el.adresseCommercialeLibelle2) adresse.push(el.adresseCommercialeLibelle2);
        if (el.adresseCommercialeLibelle3) adresse.push(el.adresseCommercialeLibelle3);
        return {
          code: el.code,
          facCode: el.faces.map(fac => fac.facCode).join(', '),
          format: el.format,
          materiel: el.materiel,
          adresse: adresse.join(', '),
          codePostal: el.codePostal,
          ville: el.ville,
          codeDepartement: el.codeDepartement,
          num: el.num,
          facNum: el.faces[0].facNum,
        };
      });
    },
    options() {
      return {
        headings: {
          ...this.trad,
        },
        filterByColumn: true,
        filterable: ['code', 'facCode', 'format', 'materiel', 'adresse', 'codePostal', 'ville', 'codeDepartement'],
        sortable: ['code', 'facCode', 'format', 'materiel', 'adresse', 'codePostal', 'ville', 'codeDepartement'],
        perPageValues: PER_PAGE_VALUE,
        perPage: 11,
        texts: TEXTS,
        columnsClasses: {},
      };
    },
  },
  methods: {
    ouvrirNouvelleFenetrePhoto(idFace) {
      if (this.site === 'aventi' || this.site === 'clg') {
        window.open(`http://antilles.affixe-logiciel.fr/Webforms/Patrimoine/D_Face.aspx?Num=${idFace}`);
      } else {
        window.open(`http://client.affixe-logiciel.fr/Webforms/Patrimoine/D_Face.aspx?Num=${idFace}`);
      }
    },
    ouvrirNouvelleFenetreNoGeo(idPanneau) {
      if (this.site === 'aventi' || this.site === 'clg') {
        window.open(`http://antilles.affixe-logiciel.fr/Webforms/Patrimoine/D_PiedPanneaux.aspx?PanNum=${idPanneau}`);
      } else {
        window.open(`http://client.affixe-logiciel.fr/Webforms/Patrimoine/D_PiedPanneaux.aspx?PanNum=${idPanneau}`);
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/panneaux/tableauPanneaux.vue